import { render, staticRenderFns } from "./EMDistinta.vue?vue&type=template&id=d0a54c46&scoped=true&"
import script from "./EMDistinta.vue?vue&type=script&lang=js&"
export * from "./EMDistinta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a54c46",
  null
  
)

export default component.exports